export default function abbreviateNumber(num = 0, fixed = 0) {
  if (num > 899) {
    return Math.ceil(num / 1000).toFixed(fixed) + 'k';
  } else if (num > 89) {
    return (Math.ceil(num / 100) * 100).toFixed(fixed);
  } else {
    return num.toFixed(fixed);
  }
}
